import CalendrierSimpleAvecBlocage from 'composant/UI/CalendrierSimple/CalendrierSimpleAvecBlocage';
import React, { useState } from 'react';
import styles from './FormulairePlanningException.module.scss';

interface FormulairePlanningExceptionProps {
  changerOnglet: (e: React.SyntheticEvent, tab: number) => void;
  setExPlanningInfo: (info: {
    title: string;
    startDate: Date;
    endDate: Date;
  }) => void;
  unavailableDatesPeriodes: Date[];
}

const FormulairePlanningException = (
  props: FormulairePlanningExceptionProps
) => {
  const [title, setTitle] = useState<string>('');

  const [periodeSelectionnee, setPeriodeSelectionnee] = React.useState<{
    debut: Date | null;
    fin: Date | null;
  }>({ debut: null, fin: null });

  const handleChangementPeriode = (dateDebut: any, dateFin: any) => {
    setPeriodeSelectionnee({ debut: dateDebut, fin: dateFin });
  };

  const handleSave = () => {
    if (!title || !periodeSelectionnee.debut || !periodeSelectionnee.fin) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    const dataToSend = {
      title: title,
      startDate: periodeSelectionnee.debut!,
      endDate: periodeSelectionnee.fin!,
    };
    props.setExPlanningInfo(dataToSend);
  };

  return (
    <div className={styles.formContent}>
      <div className={styles.formGroup}>
        <label htmlFor="planningTitle">Titre du planning :</label>
        <input
          id="planningTitle"
          type="text"
          placeholder="Ex: Fermeture estivale, Maintenance..."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className={styles.formGroup}>
        <label>Période de l'exception :</label>
        <div className={styles.calendarWrapper}>
          <CalendrierSimpleAvecBlocage
            onPeriodChange={handleChangementPeriode}
            titre="Période d'activité"
            datesBloquees={props.unavailableDatesPeriodes}
          />
        </div>
      </div>

      <div className={styles.buttonsContainer}>
        <button
          className={styles.buttonSecondary}
          onClick={(e) => props.changerOnglet(e, 1)}
        >
          Retour
        </button>
        <button
          className={styles.buttonPrimary}
          onClick={handleSave}
          disabled={
            !title || !periodeSelectionnee.debut || !periodeSelectionnee.fin
          }
        >
          Créer le planning
        </button>
      </div>
    </div>
  );
};

export default FormulairePlanningException;
